import { useSeo } from "@/lib/seo";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl text-white mb-3">{title}</h2>
    <div className="text-gray-400 leading-relaxed space-y-3 text-sm">{children}</div>
  </div>
);

export default function Privacy() {
  useSeo({ title: "Privacy Policy", description: "Informativa sulla privacy di Opera Real Estate Partners (GDPR)." });
  return (
    <div className="bg-[#0D1B2A]">
      <section className="max-w-3xl mx-auto px-5 lg:px-8 py-20">
        <div className="border border-[#C5A059]/30 bg-[#1E2229] p-4 mb-10">
          <p className="text-sm text-[#C5A059]">
            ⚠︎ BOZZA — testo standard da far validare da un legale prima della pubblicazione.
          </p>
        </div>
        <h1 className="font-display font-light text-4xl text-white mb-8">Privacy Policy</h1>

        <Section title="1. Titolare del trattamento">
          <p>
            Titolare del trattamento è SALEN S.R.L. (che promuove l'iniziativa OPERA Real Estate
            Partners), con sede legale in SS12 Abetone e Brennero KM 5+812 n. 7/C, 56017 San Giuliano
            Terme (PI), C.F./P.IVA 02353510502, email: privacy@operapartners.it — PEC: salensrl@pec.it.
          </p>
        </Section>
        <Section title="2. Dati raccolti">
          <p>
            Raccogliamo i dati che ci fornisci volontariamente tramite i moduli di contatto (nome,
            cognome, email, telefono, profilo, eventuali informazioni su capitale e orizzonte
            temporale, messaggio) e dati di navigazione tramite cookie tecnici e, previo consenso, di
            misurazione.
          </p>
        </Section>
        <Section title="3. Finalità e base giuridica">
          <p>
            I dati sono trattati per rispondere alle richieste (esecuzione di misure precontrattuali),
            per adempimenti di legge e, previo consenso, per l'invio della newsletter. La base
            giuridica è l'art. 6 GDPR.
          </p>
        </Section>
        <Section title="4. Conservazione">
          <p>
            I dati sono conservati per il tempo necessario alle finalità indicate e agli obblighi di
            legge, dopodiché vengono cancellati o anonimizzati.
          </p>
        </Section>
        <Section title="5. Diritti dell'interessato">
          <p>
            Puoi esercitare i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e
            opposizione scrivendo a privacy@operapartners.it. Hai diritto di reclamo al Garante.
          </p>
        </Section>
        <Section title="6. Comunicazione dei dati">
          <p>
            I dati possono essere comunicati a fornitori di servizi (es. hosting, invio email) nominati
            responsabili del trattamento, e non sono oggetto di diffusione.
          </p>
        </Section>
      </section>
    </div>
  );
}
